// Socket.io client — canli ticket/queue event akisi icin tekil baglanti.
// Backend RabbitMQ'dan gelen olaylari "queue.*" isimleriyle broadcast ediyor.
import { io, Socket } from 'socket.io-client';
import { API_BASE } from './support';

export type QueueEventName =
  | 'queue.notification.email'
  | 'queue.notification.push'
  | 'queue.notification.sms'
  | 'queue.ticket.assignment'
  | 'queue.ticket.status.update'
  | 'queue.ticket.escalation'
  | 'queue.ticket.audit.log'
  | string;

export interface QueueEvent<TPayload = any> {
  event: string;
  payload: TPayload;
  timestamp: string;
}

// Socket gecici olarak devre disi birakildi. Tekrar acmak icin SOCKET_ENABLED = true yap.
const SOCKET_ENABLED = false;

let socket: Socket | null = null;

export function getSocket(): Socket | null {
  if (!SOCKET_ENABLED) return null;
  if (!socket) {
    socket = io(API_BASE, {
      transports: ['websocket', 'polling'],
      autoConnect: true,
      reconnection: true,
    });
  }
  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

// Tum queue.* olaylarini dinle. Donen fonksiyon ile unsubscribe.
export function onQueueEvent(
  handler: (name: QueueEventName, data: QueueEvent) => void,
): () => void {
  const s = getSocket();
  if (!s) return () => {};
  const listener = (name: string, data: QueueEvent) => {
    if (typeof name === 'string' && name.startsWith('queue.')) {
      handler(name, data);
    }
  };
  s.onAny(listener);
  return () => {
    s.offAny(listener);
  };
}

// Belirli bir event ismi icin dinleyici.
export function onQueueEventName<T = any>(
  name: QueueEventName,
  handler: (data: QueueEvent<T>) => void,
): () => void {
  const s = getSocket();
  if (!s) return () => {};
  s.on(name, handler as any);
  return () => {
    s.off(name, handler as any);
  };
}
